const Utils = {
  /**
   * ios safari下Date无法处理带"-"的日期格式
   * @param timeStr
   * @returns {*|string}
   */
  fixIosTime (timeStr) {
    if (!timeStr) return timeStr;
    let tempTime = timeStr;
    const count = timeStr.toString().split('-').length - 1;
    if (count === 2) {
      tempTime = timeStr.replace(/-/g, '/').split('.')[0];
    }
    return tempTime;
  },
  /**
   * @description 格式化时间显示
   * @param time
   * @param format
   */
  formatTime (time, format = 'yyyy-MM-dd HH:mm:ss') {
    if (time) {
      let tempTime = time;
      // 包含两个横线
      const count = time.toString().split('-').length - 1;
      if (count === 2) {
        tempTime = time.replace(/-/g, '/').split('.')[0];
      }
      const t = new Date(tempTime);
      const tf = function (i) {
        return (i < 10 ? '0' : '') + i;
      };
      return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
        switch (a) {
          case 'yyyy':
            return tf(t.getFullYear());
          case 'MM':
            return tf(t.getMonth() + 1);
          case 'mm':
            return tf(t.getMinutes());
          case 'dd':
            return tf(t.getDate());
          case 'HH':
            return tf(t.getHours());
          case 'ss':
            return tf(t.getSeconds());
        }
      });
    } else {
      return '---';
    }
  },
  /**
   * @description 判断是否是移动端
   * @returns {boolean}
   */
  isMobile () {
    return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
  },

  /**
   * @description 判断是否是微信内打开
   * @returns {boolean}
   */
  isWechat () {
    const ua = navigator.userAgent.toLowerCase();
    const matchData = ua.match(/MicroMessenger/i);
    return matchData && matchData[0] === 'micromessenger';
  },

  /**
   * @description 解析获取url中的某个query参数
   * @param url
   * @param key
   */
  getQueryValue (url, key) {
    const regex = new RegExp(key + '=([^&]*)', 'i');
    if (url.match(regex)) {
      return url.match(regex)[1];
    } else {
      return url.match(regex);
    }
  },

  /**
   * @description 格式化金额
   * @param amount
   */
  formatMoney (amount) {
    return amount.replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,');
  },

  /**
   * @description 生成全局唯一ID
   * @return {string}
   */
  generateUUID () {
    let d = new Date().getTime();
    if (window.performance && typeof window.performance.now === 'function') {
      d += performance.now(); // use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  },

  /**
   * @description 是否对象
   * @param val
   * @returns {boolean}
   */
  isPlainObject (val) {
    return Object.prototype.toString.call(val) === '[object Object]';
  },

  /**
   * @description 是否数组
   * @param val
   * @returns {boolean}
   */
  isArray (val) {
    return Object.prototype.toString().call(val) === '[object Array]';
  },

  /**
   * @description 是否日期
   * @param val
   * @returns {boolean}
   */
  isDate (val) {
    return Object.prototype.toString().call(val) === '[object Date]';
  },

  /**
   * @description 是否函数
   * @param val
   * @returns {boolean}
   */
  isFunction (val) {
    return Object.prototype.toString().call(val) === '[object Function]';
  },

  /**
   * @description 校验手机号格式
   * @param number
   * @return {*|boolean}
   */
  validatePhone (number) {
    const reg = /^1[0-9]{10}$/;
    return number && reg.test(number);
  },

  /**
   * @description 校验身份证基本格式
   * @param number
   * @returns {boolean}
   */
  validateID (number) {
    if (!number) return false;
    const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/;
    return reg.test(number);
  },
  /**
   * 返回两个时间之间的时间差
   * @param start
   * @param end
   * @param unit // s：秒；ss:毫秒
   * @returns {number}
   */
  getTimeDiff (start, end, unit = 's') {
    if (!start || !end) return 0;
    const endTime = end.replace(new RegExp('-', 'gm'), '/');
    const startTime = start.replace(new RegExp('-', 'gm'), '/');
    const startStamp = (new Date(startTime)).getTime(); // 得到毫秒数
    const endStamp = (new Date(endTime)).getTime(); // 得到毫秒数
    if (unit === 's') {
      return (endStamp - startStamp) / 1000;
    } else {
      return (endStamp - startStamp);
    }
  },
  /***
   * 返回当前时间，往过去和往未来推移一定偏移量后的日期范围，开始时间00：00：00点开始，结束时间23：59：59
   * @param prevOffset 往过去推的偏移量天数
   * @param nextOffset 往未来推的偏移量天数
   * @param format 格式化字符串
   * @returns {(string|string)[]}
   */
  getTimeRange (prevOffset = 1, nextOffset = 1, format = 'yyyy-MM-dd HH:mm:ss') {
    if (prevOffset <= 0 || nextOffset <= 0) {
      throw new Error('prevOffset and nextOffset must more than 0');
    }
    const start = new Date(new Date(Date.now() - 3600 * 1000 * 24 * (prevOffset - 1)).setHours(0, 0, 0, 0));
    const end = new Date(new Date(Date.now() + 3600 * 1000 * 24 * (nextOffset - 1)).setHours(23, 59, 59, 0));
    return [Utils.formatTime(start, format), Utils.formatTime(end, format)];
  },

  /**
   * 获取日期区间内的日期数组
   * @param start
   * @param end
   * @param format
   * @returns
   */
  parseDateRange (start, end, format = 'yyyy-MM-dd') {
    if (!start || !end) return;
    start = Utils.fixIosTime(start);
    end = Utils.fixIosTime(end);
    const startStamp = new Date(start).getTime();
    const endStamp = new Date(end).getTime();
    const dateArr = [];
    for (let i = 0; i <= endStamp - startStamp; i += 86400000) {
      const stamp = new Date(startStamp + i);
      dateArr.push(Utils.formatTime(stamp, format));
    }
    return dateArr;
  },

  /**
   * 进入全屏
   */
  documentFullscreen () {
    const isFullScreen = !!(
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullScreenElement ||
      document.webkitFullscreenElement || null
    );
    const element = document.documentElement;
    // 判断是否已经是全屏
    // 如果是全屏，退出
    if (isFullScreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      // 否则，进入全屏
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        // IE11
        element.msRequestFullscreen();
      }
    }
  },

  /**
   * 防抖函数，总是在停止操作delay时间后，执行fn
   * @param fn
   * @param delay
   * @returns {function(): void}
   */
  debounce (fn, delay) {
    let timer;
    return function () {
      const _this = this;
      const args = arguments;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        fn.apply(_this, args);
      }, delay);
    };
  },

  /**
   * 节流，总是固定频率执行
   * @param fn
   * @param delay
   * @returns {function(): undefined}
   */
  throttle (fn, delay) {
    let timer;
    return function () {
      const _this = this;
      const args = arguments;
      if (timer) {
        return;
      }
      timer = setTimeout(function () {
        fn.apply(_this, args);
        timer = null; // 在delay后执行完fn之后清空timer，此时timer为假，throttle触发可以进入计时器
      }, delay);
    };
  }
};

export default Utils;
